export default __webpack_public_path__ + "static/media/ampliacion.2e5b08dc.jpeg";